import { render, staticRenderFns } from "./ComponentSectionMenu.vue?vue&type=template&id=8c7a236e&"
import script from "./ComponentSectionMenu.vue?vue&type=script&lang=js&"
export * from "./ComponentSectionMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports